import { useEffect } from "react";

const SITE_URL = "https://www.whenpigsflyfamilybbq.com";
const BASE = "When Pigs Fly Family BBQ";

function upsertMeta(attr, value, content) {
  let el = document.head.querySelector(`meta[${attr}="${value}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Set the browser tab title, meta description, canonical URL, and OG tags
 * for the current page. Runs on mount and whenever inputs change.
 *
 * Usage:
 *   usePageMeta({
 *     title: "Menu & Order",
 *     description: "See the full When Pigs Fly menu — brisket, ribs, wings…",
 *     path: "/menu",
 *   });
 */
export default function usePageMeta({ title, description, path = "", image = null }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${BASE}` : BASE;
    const url = `${SITE_URL}${path}`;
    const imgUrl = image ? (image.startsWith("http") ? image : `${SITE_URL}${image}`) : null;

    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    if (imgUrl) {
      upsertMeta("property", "og:image", imgUrl);
      upsertMeta("property", "og:image:secure_url", imgUrl);
      upsertMeta("name", "twitter:image", imgUrl);
      upsertMeta("name", "twitter:card", "summary_large_image");
    }
    upsertCanonical(url);
  }, [title, description, path, image]);
}
